<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img :src="require('@/assets/images/logo/logo128pxCarre.png')" width="80" alt="logo" />
        <!-- <h2 class="brand-text text-primary ml-1">{{ appName }}</h2> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" style="max-width: 550px" alt="Connexion" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5 svg_login_background"
      >
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold d-none d-md-block" title-tag="h2">
            Bienvenu sur CBP 👋
          </b-card-title>
          <!-- <b-card-text class="mb-2 d-none d-md-block  text-primary">
            Veuillez vous connecter à votre compte.
          </b-card-text> -->
          <b-card-text class="mb-2 d-none d-md-block text-primary">
            Connectez-vous à votre compte
          </b-card-text>

          <br />

          <b-alert variant="primary" show>
            <!-- <div class="alert-body font-small-2">
              <p>
                <small class="mr-50"><span class="font-weight-bold">Admin:</span> admin@demo.com | admin</small>
              </p>
              <p>
                <small class="mr-50"><span class="font-weight-bold">Client:</span> client@demo.com | client</small>
              </p>
            </div> -->
            <!-- <feather-icon
              v-b-tooltip.hover.left="'Votre compte doit avoir les accèss'"
              icon="HelpCircleIcon"
              size="18"
              class="position-absolute"
              style="top: 10; right: 10;"
            /> -->
          </b-alert>

          <!-- form -->
          <validation-observer ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="auth">
              <!-- email -->
              <b-form-group label="Email / Compte" label-for="account">
                <validation-provider
                  #default="{ errors }"
                  vid="account"
                  rules="required"
                  name="account"
                >
                  <!-- vid="email"
                  rules="required|email" -->

                  <b-form-input
                    id="account"
                    v-model="account"
                    :state="errors.length > 0 ? false : null"
                    name="account"
                    placeholder="Votre compte ici"
                    autocomplete="off"
                  />

                  <b-form-invalid-feedback>
                      Compléter votre email ou téléphone ici
                  </b-form-invalid-feedback>

                  <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                </validation-provider>
              </b-form-group>

              <!-- forgot password // -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Mot de passe</label>
                  <b-link :to="{ name: 'auth-forgot-password' }">
                    <small>Mot de passe oublié?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Votre Mot de passe"
                      autocomplete="off"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-invalid-feedback>
                      Compléter votre mot de passe ou pin ici
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Restez connecté
                  <span class="text-warning">(Mode Hors Ligne)</span>
                </b-form-checkbox>
              </b-form-group> -->

              <!-- refreshSystem -->
              <!-- <b-form-group v-if="refreshSystemShow == true || status == true">
                <b-form-checkbox
                  id="refreshSystem"
                  v-model="refreshSystem"
                  name="refreshSystem"
                  v-on:change="actualizeSystem"
                >
                  Actualiser le sysème
                  <span class="text-success">(Mise à jour)</span>
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="loading"
              >
                <LoadingIcon
                  v-if="loading"
                  style="width: 24px; float: center"
                ></LoadingIcon>

                <span v-if="loading == false">Se connecter</span>
                
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span>Vous etes nouveau ? </span>
            <b-link :to="{ name: 'auth-register', params: { referer: 'cbp-' } }">
              <span class="text-success"><strong><u>&nbsp;S'inscrire ici</u></strong></span>
            </b-link>
          </b-card-text>

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">ou</div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Logo from "@core/layouts/components/Logo.vue";
import LoadingIcon from "@core/layouts/components/Loading.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import { initialAbility } from "@/libs/acl/config";
import useJwt from "@/auth/jwt/useJwt";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import { $themeConfig } from "@themeConfig";
import axios from "axios";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    Logo,
    ValidationProvider,
    ValidationObserver,
    LoadingIcon,
    BFormInvalidFeedback,
  },
  mixins: [togglePasswordVisibility],
  setup() {
    // App Name
    const { appName, appLogoImage, api_endpoint } = $themeConfig.app;
    return {
      appName,
      appLogoImage,
      api_endpoint,
      LoadingIcon,
    };
  },
  data() {
    return {
      status: "",
      account: "", //admin@demo.com
      password: "", //admin
      sideImg: require("@/invest.svg"),
      //
      loading: false,
      refreshSystem: false,
      refreshSystemShow: false,

      // validation rules
      required,
      email,
      contacts: Array,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  created() {
    // recuperer autorisation globales
    //
    // this.getPermissions("admin");
  },
  mounted() {
    var last_route_name = localStorage.getItem("last_route_name");
    if (
      last_route_name != "" &&
      last_route_name != null &&
      last_route_name != undefined
    ) {
      // s il ya de route en attente
      this.refreshSystemShow = true;
    }

    // recuperation des donnees
    if (localStorage.getItem("menus") == null) {
      // online get
      // get menus
      this.getMenus();
    } else {
      if (this.refreshSystem == true) {
        // refresh menu
        this.getMenus();
      } else {
        this.loading = false;
      }
    }
  },
  methods: {
    showToast(header, message, variant, icon, position, timeout) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: header,
            icon,
            text: message,
            variant,
          },
        },
        {
          position,
          timeout,
        }
      );
    },
    actualizeSystem() {
      if (this.refreshSystem == true) {
        // refresh menu
        this.getMenus();
      }
    },
    async getMenus(mode) {
      this.loading = true;
      localStorage.removeItem("menus");
      myApi({
        url: "get-all-menus",
        method: "get",
      })
        .then((response) => {
          localStorage.setItem("menus", JSON.stringify(response.data.data));
          // activate login button
          this.loading = false;
        })
        .catch((error) => {
          this.loading = true;
        });
    },
    async login(online) {

      var userOnline = window.navigator.onLine ? "on" : "off";
      this.loading = true;
      var maintenance_mode = true;

      if (online == 1) {
        // online login is required
        if (maintenance_mode == false) {
          if (userOnline == "off") {
            this.loading = false;
            this.$toast({
              component: ToastificationContent,
              position: "top-center",
              props: {
                title: `Erreur Réseau`,
                icon: "InfoIcon",
                variant: "warning",
                text: "Vérifier votre connectivité Internet",
              },
            });
            this.loading = false;
            return;
          }
        }

        let formData = new FormData();
        formData.append("email", this.account);
        formData.append("password", this.password);

        await axios
          .post($themeConfig.app.api_endpoint + `auth/login`, formData)
          .then((response) => {
            var userData = response.data.data;

            var accessToken = response.data.access_token;
            var accessTokenType = response.data.token_type;

            $themeConfig.app.api_endpoint_access_token = accessToken;
            $themeConfig.app.refresh_required = true;

            // ok
            localStorage.setItem("userData", JSON.stringify(userData));
            localStorage.setItem("token", accessToken);
            this.loading = false;
            this.login(2);
          })
          .catch((error) => {
            this.loading = false;
            this.$toast({
              component: ToastificationContent,
              position: "top-center",
              props: {
                title: `Erreur Survenu`,
                icon: "AlertIcon",
                variant: "warning",
                text: "Vérifier votre compte/email et votre mot de passe",
              },
            });
          });
      } else {
        // offline

        useJwt
          .login({
            email: this.account,
            password: this.password,
          })
          .then((response) => {
            this.loading = false;

            let token = localStorage.getItem("token");
            if (token != null && token != undefined) {
              const { userData } = response.data;
              useJwt.setToken(userData.accessToken);
              useJwt.setRefreshToken(userData.refreshToken);
              // store user permission on the instance
              localStorage.setItem("userData", JSON.stringify(userData));
              localStorage.setItem("msgtasktimeout", userData.msgtasktimeout);

              // update api config
              myApi.defaults.headers.common[
                "Authorization"
              ] = `Bearer ${localStorage.getItem("token")}`;

              // permissions
              this.$ability.update(userData.ability);

              $themeConfig.app.userPermissions = userData.special_permissions;
              window.vueSpatiePermissions = userData.special_permissions;

              // get permissions
              console.log("uswindow.Laravel");
              localStorage.setItem(
                "roles-permissions",
                window.vueSpatiePermissions
              );
              console.log(window.vueSpatiePermissions);
              console.log("window.Laravel end");
            } else {
              this.$toast({
                component: ToastificationContent,
                position: "top-center",
                props: {
                  title: `Erreur Survenu`,
                  icon: "InfoIcon",
                  variant: "warning",
                  text: response.message, // error.response.data.error
                },
              });
            } 

            // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
            if ($themeConfig.app.refresh_required == true) {
              // this.$router.push({ name: "dashboard-default" });
              console.log("refresh required");

              var last_route_name = localStorage.getItem("last_route_name");
              if (
                last_route_name != "" &&
                last_route_name != null &&
                last_route_name != undefined
              ) {
                localStorage.removeItem("last_route_name");
                window.location.href = last_route_name;
              } else {
                window.location.href = "/";
              }
            } else {
              // ---------------------------------
              console.log("no refresh required");
              // ---------------------------------
              this.$router
                .replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-center",
                    props: {
                      title: `Bienvenu ${
                        userData.fullName || userData.username
                      }`,
                      icon: "CoffeeIcon",
                      variant: "success",
                      text: `Vous vous êtes connecté avec succès en tant que ${userData.role}. Vous pouvez maintenant commencer à explorer !`,
                    },
                  });
                });
              
            }
          })
          .catch((error) => {
            console.log(error)
            this.loading = false;
            this.$toast({
              component: ToastificationContent,
              position: "top-center",
              props: {
                title: `Erreur d'Authentification`,
                icon: "InfoIcon",
                variant: "warning",
                text: error.response.data.error, // error.response.data.error
              },
            });
          });
      }
    },
    auth() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          if (
            // offline
            localStorage.getItem("userData") == null ||
            localStorage.getItem("userData") == undefined
          ) {
            this.login(1);
          } else {
            // online login
            this.login(2);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

<style lang="css">
.svg_login_background{
background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.dev/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1120%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(255%2c 255%2c 255%2c 1)'%3e%3c/rect%3e%3cuse xlink:href='%23SvgjsSymbol1127' x='0' y='0'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsSymbol1127' x='720' y='0'%3e%3c/use%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1120'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3cpath d='M-1 0 a1 1 0 1 0 2 0 a1 1 0 1 0 -2 0z' id='SvgjsPath1125'%3e%3c/path%3e%3cpath d='M-3 0 a3 3 0 1 0 6 0 a3 3 0 1 0 -6 0z' id='SvgjsPath1124'%3e%3c/path%3e%3cpath d='M-5 0 a5 5 0 1 0 10 0 a5 5 0 1 0 -10 0z' id='SvgjsPath1121'%3e%3c/path%3e%3cpath d='M2 -2 L-2 2z' id='SvgjsPath1122'%3e%3c/path%3e%3cpath d='M6 -6 L-6 6z' id='SvgjsPath1123'%3e%3c/path%3e%3cpath d='M30 -30 L-30 30z' id='SvgjsPath1126'%3e%3c/path%3e%3c/defs%3e%3csymbol id='SvgjsSymbol1127'%3e%3cuse xlink:href='%23SvgjsPath1121' x='30' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='30' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='30' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='30' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='30' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='30' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='30' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='30' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='30' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='30' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='90' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='90' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='90' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='90' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='90' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='90' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1124' x='90' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='90' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1125' x='90' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='90' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='150' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='150' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='150' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1125' x='150' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='150' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1126' x='150' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)' stroke-width='3'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1125' x='150' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='150' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='150' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1126' x='150' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)' stroke-width='3'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1126' x='210' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)' stroke-width='3'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='210' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='210' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='210' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1126' x='210' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)' stroke-width='3'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='210' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='210' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='210' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='210' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='210' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1126' x='270' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)' stroke-width='3'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1124' x='270' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='270' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='270' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='270' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1125' x='270' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='270' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='270' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='270' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='270' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='330' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='330' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='330' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='330' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1124' x='330' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='330' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='330' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='330' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1126' x='330' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)' stroke-width='3'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='330' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='390' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='390' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='390' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1125' x='390' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1124' x='390' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1125' x='390' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='390' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='390' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='390' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='390' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='450' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1125' x='450' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1124' x='450' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='450' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1125' x='450' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1125' x='450' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='450' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1126' x='450' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)' stroke-width='3'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='450' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='450' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='510' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1124' x='510' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='510' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='510' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='510' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='510' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='510' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1125' x='510' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='510' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='510' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='570' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1124' x='570' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1126' x='570' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)' stroke-width='3'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='570' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1124' x='570' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='570' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='570' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='570' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='570' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='570' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='630' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='630' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='630' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='630' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='630' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='630' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1124' x='630' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='630' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='630' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='630' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='690' y='30' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='690' y='90' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1125' x='690' y='150' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='690' y='210' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1123' x='690' y='270' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1124' x='690' y='330' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='690' y='390' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='690' y='450' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1121' x='690' y='510' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3cuse xlink:href='%23SvgjsPath1122' x='690' y='570' stroke='rgba(237%2c 246%2c 255%2c 1)'%3e%3c/use%3e%3c/symbol%3e%3c/svg%3e");
}
</style>
